import React, { useState } from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, CircularProgress, useTheme, Skeleton, styled } from "@mui/material";
import { useGetAllNcrQuery } from "store/slices/apis/ncrPackageSlice";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

type Person = {
  //sno: string;
  ncrNumber: string;
  contactor_Name: string;
  project_name: string;
  package: string;
  dateOfIssueOfNCR: string;
  actualExpectedDateOfCorrectiveActionCompeltion: string;
  currentStatus: string;
  plannedDateOfCorrectiveActionCompeltion: string;
};

const columns: MRT_ColumnDef<Person>[] = [
  // { accessorKey: 'sno', header: 'S No.' },
  { accessorKey: 'ncrNumber', header: 'NCR Number', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'contactor_Name', header: 'Consultant/Contractor', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center', sx: { whiteSpace: 'nowrap' }, }, },
  { accessorKey: 'package', header: 'Package', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'dateOfIssueOfNCR', header: 'Date of issue Of NCR', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'actualExpectedDateOfCorrectiveActionCompeltion', header: 'Status as on Date', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'currentStatus', header: 'Status', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'plannedDateOfCorrectiveActionCompeltion', header: 'Planned Date of corrective Action completion', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
];

// Format helper
const formatDate = (dateString?: string) =>
  dateString ? dayjs(dateString).format('DD/MM/YY') : '';

// Flatten formatter (no children)
const formatScheduleData = (data: any[]): Person[] =>
  data.map((item) => ({
    // sno: item.sno,
    ncrNumber: item.ncrNumber,
    contactor_Name: item.contactor_Name,
    package: item.package,
    dateOfIssueOfNCR: formatDate(item.dateOfIssueOfNCR),
    actualExpectedDateOfCorrectiveActionCompeltion: formatDate(item.actualExpectedDateOfCorrectiveActionCompeltion),
    currentStatus: item.currentStatus,
    plannedDateOfCorrectiveActionCompeltion: formatDate(item.plannedDateOfCorrectiveActionCompeltion),
  }));

export default function QualityNCRList() {

  const newtheme = useTheme();
  const { projectId } = useParams();

  const { data, isLoading, error } = useGetAllNcrQuery({
    projectId,
    sortBy: "createddate",
    sortOrder: "desc",
    approved_status: "Approved",
  });

  const dataval: Person[] = data?.data?.ncr ? formatScheduleData(data?.data?.ncr) : [];


  return (
    <Box sx={{
      width: "100%", border: "1px solid #D8D8D8", mt: "10px", borderRadius: "12px", overflow: "hidden",
    }}>
      <Box sx={{ backgroundColor: "#fff", p: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 500, color: `${newtheme?.customSettings?.themeColor}`, fontSize: "18px" }}>
          NCR Table
        </Typography>
      </Box>
      {isLoading ? (
        <Box display="flex" justifyContent="center" mt={4} pb={1}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">Failed to load data.</Typography>
      ) : (
        <MaterialReactTable
          columns={columns}
          data={dataval}
          // enableRowNumbers
          // rowNumberDisplayMode="static"
          // displayColumnDefOptions={{
          //   'mrt-row-numbers': {
          //     header: 'S No',
          //     size: 100,
          //     muiTableHeadCellProps: { align: 'center' },
          //     muiTableBodyCellProps: { align: 'center' },
          //   },
          // }}
          muiTableHeadCellProps={{
            sx: {
              fontWeight: 500,
              fontSize: "14px",
              color: "#505258",
              padding: "10px 14px",
              backgroundColor: "#F8F8F8",
              border: "1px solid #D8D8D8",
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              fontWeight: 400,
              fontSize: "14px",
              color: "#505258",
              padding: "10px 14px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #D8D8D8",
              opacity: "0.54"
            },
          }}
          enableExpanding={false}
          enableRowSelection={false}
          enableFullScreenToggle={false}
          enableColumnActions={false}
        />
      )}
    </Box>
  );
}
